import styled, { keyframes } from "styled-components";
import {
  BG_GAMES,
  BOX_SHADOW,
  DARKER,
  PRIMARY,
  SECONDARY,
} from "../../const/colors";
import { mobile_normal, mobile_title } from "../../const/fonts";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  darken,
} from "@mui/material";

export const Container = styled.div`
  background-color: #ffff;
  border: 1px solid ${PRIMARY};
  position: relative;
  width: 100%;
  overflow-x: hidden;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    padding-top: 62px;
    padding-bottom: 1rem;
    border: none;
    //overflow: hidden;
  }
`;

export const ButtonClose = styled.button`
  border: none;
  background-color: #fff;
  color: ${SECONDARY};
  padding: 0.16rem 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 0;
  svg {
    font-size: 2.5rem;
  }
  &:hover {
    background-color: #93291e;
    svg {
      color: #fff;
    }
  }
  @media screen and (max-width: 768px) {
    display: initial;
    & svg {
      font-size: 35px;
    }
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY};
  position: relative;

  h2 {
    padding: 0.7rem;
    margin: 0 auto;
    color: ${SECONDARY};
    font-weight: 800;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    //margin: 2rem auto;
    h2 {
      font-size: ${mobile_title};
    }
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    margin-bottom: 0;
  }
`;

export const Form = styled.div.attrs((props) => ({
  className: props.className,
}))`
  padding: 3rem;

  &.tupay {
    padding: 1rem;
  }
  &.pay4fun {
    padding: 1rem;
  }
  &.nuvei {
    padding: 1rem;
  }
  &.astropay {
    padding: 1rem;
  }
  &.pagofacil {
    padding: 0.50rem;
  }
  @media screen and (min-width: 1020px) and (max-width: 1080px) {
    img{
       &.astro1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.astro2 {
        width: 60% !important;
        margin-left: 19.5% !important;
        margin-bottom: -4% !important;

      }
      &.astro3 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro4 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro5 {
        width: 60% !important;
        margin-left: 21% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.pay4fun2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun3{
         width: 25% !important;
         margin-bottom: 2% !important;
         margin-left: 38% !important;
      }
      &.pay4fun4 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 4% !important;

      }
      &.tupa1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.tupa2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.tupa3{
         width: 25% !important;
         margin-left: 38% !important;
      }
      &.tupa4 {
        width: 65% !important;
        margin-left: 18% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 65% !important;
        margin-left: 17% !important;
        margin-bottom: 2% !important;

      }
      &.totalpago1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.totalpago2 {
        width: 60% !important;
        margin-left: 19.5% !important;
        margin-bottom: -4% !important;

      }
      &.qrpagofacil {
        width: 50% !important;
        margin-left: 25% !important;
      }
       &.qrpagofacilotro {
        width: 40% !important;
        margin-left: 30% !important;
      }

      &.R4{
         width: 30% !important;
         margin-bottom: 4% !important;
         margin-left: 35.5% !important;
      }
      &.R402 {
        width: 60% !important;
        margin-left: 20.5% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito2 {
        width: 50% !important;
        margin-left: 24.5% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaRetiro {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 7px !important;

      }
      &.pyg0{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.pyg1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.pyg2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
    }
  }
  @media screen and (min-width: 920px) and (max-width: 1020px) {
    img{
       &.astro1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.astro2 {
        width: 60% !important;
        margin-left: 19.5% !important;
        margin-bottom: -4% !important;

      }
      &.astro3 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro4 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro5 {
        width: 60% !important;
        margin-left: 21% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.pay4fun2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun3{
         width: 25% !important;
         margin-bottom: 2% !important;
         margin-left: 38% !important;
      }
      &.pay4fun4 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 4% !important;

      }
       &.tupa1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.tupa2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
       &.tupa3{
         width: 25% !important;
         margin-left: 38% !important;
      }
      &.tupa4 {
        width: 65% !important;
        margin-left: 18% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 65% !important;
        margin-left: 17% !important;
        margin-bottom: 2% !important;

      }
       &.totalpago1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.totalpago2 {
        width: 60% !important;
        margin-left: 19.5% !important;
        margin-bottom: -4% !important;

      }
      &.qrpagofacil {
        width: 50% !important;
        margin-left: 25% !important;
      }
      &.qrpagofacilotro {
        width: 40% !important;
        margin-left: 30% !important;
      }

      &.R4{
         width: 30% !important;
         margin-bottom: 4% !important;
         margin-left: 35.5% !important;
      }
      &.R402 {
        width: 70% !important;
        margin-left: 16% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito2 {
        width: 50% !important;
        margin-left: 24.5% !important;
        margin-bottom: -4% !important;

      }
       &.guatemalaRetiro {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 6px !important;

      }
      &.pyg0{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.pyg1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.pyg2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 1% !important;

      }
    }
  }
  @media screen and (min-width: 820px) and (max-width: 920px) {
    img{
       &.astro1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.astro2 {
        width: 60% !important;
        margin-left: 19.5% !important;
        margin-bottom: -4% !important;

      }
      &.astro3 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro4 {
        width: 60% !important;
        margin-left: 19% !important;
        margin-bottom: -4% !important;

      }
      &.astro5 {
        width: 60% !important;
        margin-left: 21% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.pay4fun2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -4% !important;

      }
      &.pay4fun3{
         width: 25% !important;
         margin-bottom: 2% !important;
         margin-left: 38% !important;
      }
      &.pay4fun4 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 4% !important;

      }

      &.tupa1{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 38% !important;
      }
      &.tupa2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -2% !important;

      }
      &.tupa3{
         width: 25% !important;
         margin-left: 38% !important;
      }
      &.tupa4 {
        width: 65% !important;
        margin-left: 18% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 65% !important;
        margin-left: 17% !important;
        margin-bottom: 2% !important;

      }
      &.totalpago1{
         width: 28% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.totalpago2 {
        width: 70% !important;
        margin-left: 17% !important;
        margin-bottom: -4% !important;

      }
      &.qrpagofacil {
        width: 50% !important;
        margin-left: 25% !important;
      }
      &.qrpagofacilotro {
        width: 40% !important;
        margin-left: 30% !important;
      }
      &.R4{
         width: 30% !important;
         margin-bottom: 4% !important;
         margin-left: 35.5% !important;
      }
      &.R402 {
        width: 70% !important;
        margin-left: 16% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -2% !important;

      }
      &.guatemalaDeposito2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -2% !important;

      }
      &.guatemalaRetiro {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 5px !important;

      }
      &.pyg0{
         width: 25% !important;
         margin-bottom: 4% !important;
         margin-left: 37% !important;
      }
      &.pyg1 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: -2% !important;

      }
      &.pyg2 {
        width: 60% !important;
        margin-left: 20% !important;
        margin-bottom: 1% !important;

      }
    }
  }
  @media screen and (min-width: 720px) and (max-width: 820px) {
    img{
       &.astro1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 33% !important;
      }
      &.astro2 {
        width: 80% !important;
        margin-left: 9% !important;

      }
      &.astro3 {
        width: 60% !important;
        margin-left: 19% !important;

      }
      &.astro4 {
        width: 60% !important;
        margin-left: 19% !important;

      }
      &.astro5 {
        width: 75% !important;
        margin-left: 13.5% !important;

      }
      &.pay4fun1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 35% !important;
      }
      &.pay4fun2 {
        width: 80% !important;
        margin-left: 10% !important;

      }
      &.pay4fun3{
         width: 33% !important;
         margin-bottom: 2% !important;
         margin-left: 35% !important;
      }
      &.pay4fun4 {
        width: 80% !important;
        margin-left: 10% !important;
        margin-bottom: 4% !important;

      }
       &.tupa1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 35% !important;
      }
      &.tupa2 {
        width: 80% !important;
        margin-left: 10% !important;

      }
      &.tupa3{
         width: 33% !important;
         margin-left: 31% !important;
      }
      &.tupa4 {
        width: 75% !important;
        margin-left: 10% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 75% !important;
        margin-left: 13% !important;
        margin-bottom: 2% !important;

      }
       &.totalpago1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 33% !important;
      }
      &.totalpago2 {
        width: 80% !important;
        margin-left: 9% !important;

      }
      &.qrpagofacil {
        width: 55% !important;
        margin-left: 22% !important;
        margin-top: 20px !important;
      }
      &.qrpagofacilotro {
        width: 43% !important;
        margin-left: 28% !important;
        margin-top: 20px !important;
      }

      &.R4{
         width: 35% !important;
         margin-bottom: 4% !important;
         margin-left: 33% !important;
      }
      &.R402 {
        width: 75% !important;
        margin-left: 13.5% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 80% !important;
        margin-left: 10% !important;

      }
      &.guatemalaDeposito2 {
        width: 65% !important;
        margin-left: 18% !important;

      }
      &.guatemalaRetiro {
        width: 80% !important;
        margin-left: 10% !important;
        margin-bottom: 5px !important;

      }
      &.pyg0{
         width: 30% !important;
         margin-bottom: 3% !important;
         margin-left: 34% !important;
      }
      &.pyg1 {
        width: 70% !important;
        margin-left: 14% !important;

      }
      &.pyg2 {
        width: 70% !important;
        margin-left: 14% !important;
         margin-bottom: 1% !important;

      }
    }
  }
  @media screen and (min-width: 620px) and (max-width: 720px) {
    img{
      &.astro1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 33% !important;
      }
      &.astro2 {
        width: 90% !important;
        margin-left: 4% !important;

      }
       &.astro3 {
        width: 70% !important;
        margin-left: 14% !important;

      }
      &.astro4 {
        width: 70% !important;
        margin-left: 14% !important;

      }
      &.astro5 {
        width: 75% !important;
        margin-left: 13.5% !important;

      }
      &.pay4fun1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 34% !important;
      }
      &.pay4fun2 {
        width: 90% !important;
        margin-left: 4% !important;

      }
      &.pay4fun3{
         width: 33% !important;
         margin-bottom: 2% !important;
         margin-left: 34% !important;
      }
      &.pay4fun4 {
        width: 90% !important;
        margin-left: 4% !important;
        margin-bottom: 4% !important;

      }
      &.tupa1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 35% !important;
      }
      &.tupa2 {
        width: 80% !important;
        margin-left: 10% !important;

      }
      &.tupa3{
         width: 33% !important;
         margin-left: 35% !important;
      }
      &.tupa4 {
        width: 80% !important;
        margin-left: 10% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 80% !important;
        margin-left: 10% !important;
        margin-bottom: 2% !important;

      }
      &.totalpago1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 33% !important;
      }
      &.totalpago2 {
        width: 90% !important;
        margin-left: 4% !important;

      }
      &.qrpagofacil {
        width: 55% !important;
        margin-left: 22% !important;
        margin-top: 30px !important;
      }
      &.qrpagofacilotro {
        width: 43% !important;
        margin-left: 28% !important;
        margin-top: 30px !important;
      }

      &.R4{
         width: 45% !important;
         margin-bottom: 4% !important;
         margin-left: 27.5% !important;
      }
      &.R402 {
        width: 95% !important;
        margin-left: 3.5% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 70% !important;
        margin-left: 10% !important;

      }
      &.guatemalaDeposito2 {
        width: 80% !important;
        margin-left: 10% !important;

      }
      &.guatemalaRetiro {
        width: 80% !important;
        margin-left: 10% !important;
        margin-bottom: 20px !important;

      }
      &.pyg0{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 32% !important;
      }
      &.pyg1 {
        width: 82% !important;
        margin-left: 8% !important;

      }
      &.pyg2 {
        width: 82% !important;
        margin-left: 8% !important;
        margin-bottom: 5% !important;

      }
    }
  }
  @media screen and (min-width: 520px) and (max-width: 620px) {
    img{
       &.astro1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 32% !important;
      }
      &.astro2 {
        width: 100% !important;
        margin-left: -2% !important;

      }
      &.astro3 {
        width: 95% !important;
        margin-left: 0% !important;

      }
      &.astro4 {
        width: 95% !important;
        margin-left: 0% !important;

      }
      &.astro5 {
        width: 95% !important;
        margin-left: 2% !important;

      }
       &.pay4fun1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 33% !important;
      }
      &.pay4fun2 {
        width: 100% !important;
        margin-left: -1% !important;

      }
      &.pay4fun3{
         width: 33% !important;
         margin-bottom: 2% !important;
         margin-left: 33% !important;
      }
      &.pay4fun4 {
        width: 100% !important;
        margin-left: -1% !important;
        margin-bottom: 4% !important;

      }
      &.tupa1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 35% !important;
      }
      &.tupa2 {
        width: 90% !important;
        margin-left: 4.5% !important;
        margin-bottom: 4% !important;

      }
      &.tupa3{
         width: 33% !important;
         margin-left: 33% !important;
      }
      &.tupa4 {
        width: 90% !important;
        margin-left: 4.5% !important;
        margin-bottom: 2% !important;

      }
      &.monnet {
        width: 90% !important;
        margin-left: 4.5% !important;
        margin-bottom: 2% !important;

      }
      &.totalpago1{
         width: 33% !important;
         margin-bottom: 3% !important;
         margin-left: 32% !important;
      }
      &.totalpago2 {
        width: 100% !important;
        margin-left: -2% !important;

      }
      &.qrpagofacil {
        width: 60% !important;
        margin-left: 18% !important;
        margin-top: 30px !important;
      }
      &.qrpagofacilotro {
        width: 55% !important;
        margin-left: 23% !important;
        margin-top: 30px !important;
      }

      &.R4{
         width: 45% !important;
         margin-bottom: 4% !important;
         margin-left: 29% !important;
      }
      &.R402 {
        width: 110% !important;
        margin-left: -2% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 90% !important;
        margin-left: 4.5% !important;
        margin-bottom: 4% !important;

      }
      &.guatemalaDeposito2 {
        width: 85% !important;
        margin-left: 8% !important;
        margin-bottom: 4% !important;

      }
      &.guatemalaRetiro {
        width: 105% !important;
        margin-left: -2.5% !important;
        margin-bottom: 4% !important;

      }
      &.pyg0{
         width: 35% !important;
         margin-bottom: 3% !important;
         margin-left: 31% !important;
      }
      &.pyg1 {
        width: 90% !important;
        margin-left: 4% !important;
        margin-bottom: 4% !important;

      }
      &.pyg2 {
        width: 90% !important;
        margin-left: 4% !important;
        margin-bottom: 7% !important;

      }
    }
  }
  @media screen and (min-width: 429px) and (max-width: 520px) {
    img{
       &.astro1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.astro2 {
        width: 110% !important;
        margin-left: -7% !important;

      }
      &.astro3 {
        width: 110% !important;
        margin-left: -8% !important;

      }
      &.astro4 {
        width: 110% !important;
        margin-left: -6% !important;

      }
      &.astro5 {
        width: 110% !important;
        margin-left: -2% !important;

      }
       &.pay4fun1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 30% !important;
      }
      &.pay4fun2 {
        width: 110% !important;
        margin-left: -6% !important;

      }
      &.pay4fun3{
         width: 40% !important;
         margin-bottom: 2% !important;
         margin-left: 30% !important;
      }
      &.pay4fun4 {
        width: 120% !important;
        margin-left: -10% !important;

      }
       &.tupa1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 30% !important;
      }
      &.tupa2 {
        width: 95% !important;
        margin-left: 2% !important;

      }
       &.tupa3{
         width: 40% !important;
         margin-left: 30% !important;
      }
      &.tupa4 {
        width: 110% !important;
        margin-left: -5% !important;
        margin-bottom: -7% !important;

      }
      &.monnet {
        width: 110% !important;
        margin-left: -6% !important;
        margin-bottom: -7% !important;

      }
      &.totalpago1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.totalpago2 {
        width: 120% !important;
        margin-left: -12% !important;

      }
      &.qrpagofacil {
        width: 75% !important;
        margin-left: 11% !important;
        margin-top: 30px !important;
      }
      &.qrpagofacilotro {
        width: 60% !important;
        margin-left: 20% !important;
        margin-top: 30px !important;
      }
      &.R4{
         width: 50% !important;
         margin-bottom: 4% !important;
         margin-left: 26% !important;
      }
      &.R402 {
        width: 120% !important;
        margin-left: -8% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 95% !important;
        margin-left: 2% !important;

      }
      &.guatemalaDeposito2 {
        width: 95% !important;
        margin-left: 1% !important;

      }
      &.guatemalaRetiro {
        width: 105% !important;
        margin-left: -3% !important;

      }
      &.pyg0{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 29% !important;
      }
      &.pyg1 {
        width: 97% !important;
        margin-left: 1% !important;

      }
      &.pyg2 {
        width: 97% !important;
        margin-left: 1% !important;
        margin-bottom: 1% !important;

      }
    }
  }
  @media screen and (min-width: 321px) and (max-width: 429px) {
    img{
       &.astro1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.astro2 {
        width: 130% !important;
        margin-left: -17% !important;

      }
      &.astro3 {
        width: 110% !important;
        margin-left: -8% !important;

      }
      &.astro4 {
        width: 110% !important;
        margin-left: -6% !important;

      }
       &.astro5 {
        width: 120% !important;
        margin-left: -7% !important;

      }
      &.pay4fun1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.pay4fun2 {
        width: 130% !important;
        margin-left: -17% !important;

      }
      &.pay4fun3{
         width: 40% !important;
         margin-bottom: 2% !important;
         margin-left: 28% !important;
      }
      &.pay4fun4 {
        width: 150px !important;
        margin-left: -17% !important;
        image-rendering: auto !important;
      }
      &.tupa1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.tupa2 {
        width: 100% !important;
        margin-left: 0% !important;

      }
       &.tupa3{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 30% !important;
      }
      &.tupa4 {
        width: 110% !important;
        margin-left: -6% !important;

      }
      &.monnet {
        width: 110% !important;
        margin-left: -8% !important;

      }
      &.totalpago1{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 28% !important;
      }
      &.totalpago2 {
        width: 130% !important;
        margin-left: -17% !important;

      }
      &.qrpagofacil {
        width: 75% !important;
        margin-left: 11% !important;
      }

      &.R4{
         width: 60% !important;
         margin-bottom: 4% !important;
         margin-left: 20% !important;
      }
      &.R402 {
        width: 145% !important;
        margin-left: -21% !important;
        margin-bottom: -4% !important;

      }
      &.guatemalaDeposito1 {
        width: 100% !important;
        margin-left: 0% !important;

      }
      &.guatemalaDeposito2 {
        width: 110% !important;
        margin-left: -8% !important;

      }
      &.guatemalaRetiro {
        width: 105% !important;
        margin-left: -3% !important;

      }
      &.pyg0{
         width: 45% !important;
         margin-bottom: 3% !important;
         margin-left: 26% !important;
      }
      &.pyg1 {
        width: 110% !important;
        margin-left: -6% !important;

      }
      &.pyg2 {
        width: 110% !important;
        margin-left: -6% !important;

      }
    }
  }
  @media screen and (min-width: 230px) and (max-width: 321px) {
    img{
       &.astro1{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.astro2 {
        width: 180% !important;
        margin-left: -40% !important;

      }
      &.astro4 {
        width: 110% !important;
        margin-left: -6% !important;

      }
      &.astro5 {
        width: 120% !important;
        margin-left: -7% !important;

      }
      &.pay4fun1{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.pay4fun2 {
        width: 180% !important;
        margin-left: -40% !important;

      }
      &.pay4fun3{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.pay4fun4 {
        width: 180% !important;
        margin-left: -40% !important;

      }
      &.tupa1{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.tupa2 {
        width: 180% !important;
        margin-left: -40% !important;

      }
       &.tupa3{
         width: 40% !important;
         margin-bottom: 3% !important;
         margin-left: 30% !important;
      }
      &.tupa4 {
        width: 95% !important;
        margin-left: 2% !important;

      }
      &.monnnet {
        width: 95% !important;
        margin-left: 2% !important;

      }
      &.totalpago1{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.totalpago2 {
        width: 180% !important;
        margin-left: -40% !important;

      }
       &.guatemalaDeposito1 {
        width: 105% !important;
        margin-left: -3% !important;

      }
      &.guatemalaDeposito2 {
        width: 110% !important;
        margin-left: -8% !important;

      }
      &.guatemalaRetiro {
        width: 105% !important;
        margin-left: -3% !important;

      }
      &.pyg0{
         width: 55% !important;
         margin-bottom: 3% !important;
         margin-left: 22% !important;
      }
      &.pyg1 {
        width: 115% !important;
        margin-left: -8% !important;

      }
      &.pyg2 {
        width: 115% !important;
        margin-left: -8% !important;

      }
      
    }
  }

  @media screen and (max-height: 700px) {
    padding: 1rem 3rem;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
    padding: 0rem 3rem;
    //height: calc(80%);
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    padding: 0rem 2rem;
   // height: calc(80%);

   // overflow-y: auto;
  }

  @media screen and (max-height: 690px) {
    //height: calc(75%);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    color: #000000;
    font-weight: bold;
    font-size: 0.8rem;
    padding: 0.5rem;
    margin-top: 0.5rem;

    > span {
      color: red;
      margin-left: 0.5rem;
    }
  }

  select,
  input {
    background-color: transparent;
    border: 1px solid ${PRIMARY};
    padding: 0.5rem;
    color: #888;
    outline: none;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  input {
    color: #000000;
    ::placeholder {
      color: #888;
    }
  }

  select:hover,
  input:hover {
    border-color: #000;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    filter: invert(1);
  }

  @media screen and (max-width: 768px) {
    text-align: center;
    label,
    input,
    select {
      font-size: ${mobile_normal};
    }
    input::placeholder,
    select::placeholder {
      text-align: center;
    }
  }
`;

export const FileUpload = styled.div`
  .file-upload-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #888;
    cursor: pointer;
    text-align: left;
    overflow: hidden;
    position: relative;
    border: 1px solid ${PRIMARY};
    font-size: 0.8rem;
    transition: all 0.3s ease;
  }

  &:hover .file-upload-select {
    border-color: #fff;
  }

  .file-upload-select .file-select-button {
    background: ${PRIMARY};
    color: ${SECONDARY};
    font-weight: bold;
    padding: 0.5rem;
  }

  .file-upload-select .file-select-name {
    padding: 0.5rem;
  }

  .file-upload-select:hover .file-select-button {
    background: #fff;
    color: ${SECONDARY};
    transition: all 0.2s ease-in-out;
  }
  .file-upload-select input[type="file"] {
    display: none;
  }

  @media screen and (max-width: 768px) {
    .file-upload-select .file-select-button {
      font-size: 0.9rem;
    }
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-height: 700px) {
    margin-top: 1rem;
  }

  @media screen and (max-width: 480px) {
    justify-content: space-evenly;
  }
`;
export const ButtonsContainerRetiro = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-height: 700px) {
    margin-top: 1rem;
  }
  @media screen and (min-width: 820px) and (max-width: 825px) {
    margin-top: -7rem !important;
  }
  @media screen and (min-width: 480px) and (max-width: 520px) {
    margin-top: -6rem !important;
  }
  @media screen and (max-width: 480px) {
    margin-top: -7rem !important;
  }
  @media screen and (min-width: 230px) and (max-width: 335px) {
    margin-top: -4rem !important;
  }
`;

export const Button = styled.button.attrs((props) => ({
  className: props.className,
}))`
  width: 40%;
  font-size: 0.9rem;
  font-weight: bold;
  border: ${(props) =>
    props.primary ? "1px solid transparent" : `1px solid ${PRIMARY}`};
  background-color: ${(props) => (props.primary ? PRIMARY : "transparent")};
  color: ${(props) => (props.primary ? SECONDARY : PRIMARY)};
  box-shadow: ${(props) => (props.primary ? BOX_SHADOW : "none")};
  padding: 0.7rem;
  margin-top: 1.5rem;
  margin-left: ${(props) => (props.primary ? "1rem" : 0)};
  transition: all 0.3s ease-in-out;

  &:hover:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    color: ${SECONDARY};
  }

  &:disabled {
    opacity: 0.8;
    box-shadow: none;
  }

  &.active {
    background-color: #fff;
    color: ${SECONDARY};
  }

  &.tupay {
    width: 48%;
  }

  @media screen and (max-width: 480px) {
    width: 50%;
    margin-top: 1rem;
  }

  @media screen and (max-height: 690px) {
    margin-top: 0.5rem;
    padding: 0.5rem;
  }
`;
export const Buttonpin = styled.button.attrs((props) => ({
  className: props.className,
}))`
  width: 40%;
  font-size: 0.9rem;
  font-weight: bold;
  border: ${(props) =>
    props.primary ? "1px solid transparent" : `1px solid ${PRIMARY}`};
  background-color: ${(props) => (props.primary ? PRIMARY : "transparent")};
  color: ${(props) => (props.primary ? SECONDARY : PRIMARY)};
  box-shadow: ${(props) => (props.primary ? BOX_SHADOW : "none")};
  padding: 0.7rem;
  margin-top: 1.5rem;
  margin-left: ${(props) => (props.primary ? "1rem" : 0)};
  transition: all 0.3s ease-in-out;

  &:hover:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    color: ${SECONDARY};
  }

  &:disabled {
    opacity: 0.8;
    box-shadow: none;
  }

  &.active {
    background-color: #fff;
    color: ${SECONDARY};
  }

  &.tupay {
    width: 48%;
  }

  @media screen and (max-width: 690px) {
    width: 100%;
    padding: 0.75rem;
    margin: 0 !important;
    max-width: 250px !important;
    color: white;
    background: rgb(20 23 44);
  }
`;

export const EmptyBancos = styled.h4`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  div {
    margin-top: 0.5rem;
  }

  div.yellow {
    color: ${PRIMARY};
  }
`;

export const DatosBancoVe = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  //height: 100px;
  width: 100%;
  background: #fff;
  border: 1px solid yellow;
  span {
    font-weight: bold;
  }

  svg {
    font-size: 1.1rem;
    margin-bottom: -0.1rem;
    cursor: pointer;
  }
  > button {
    margin: 0 !important;
  }
`;

export const InputContainerCedula = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const InputContainerCedulaEl = styled(InputContainer)`
  flex: 1;
  input {
    padding: 0.55rem;
    width: 100%;
  }
`;

export const ErrorSpan = styled.span`
  font-size: 14px;
  color: #c21010;
  padding-top: 0.3rem;
`;

export const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  border-radius: 0 !important;

  ::before {
    opacity: 0 !important;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 0;
  }
`;

export const AccordionHeader = styled(AccordionSummary)`
  color: #fff !important;
  font-weight: bold !important;
  margin: 0 auto !important;
  border-bottom: 1px solid ${PRIMARY} !important;

  div.title {
    display: flex;
    flex-direction: column;
    span {
      font-size: 0.7rem !important;
    }
  }

  .subtitle {
    padding: 0.5rem 0;
  }
`;

export const AccordionContent = styled(AccordionDetails)`
  background: transparent;
  color: #fff;
  padding: 0 !important;

  > div.pagoEfectivo {
    padding: 1rem 2rem !important;
    h3,
    h4 {
      margin: 0.5rem 0;
    }
    div {
      padding: 0.25rem;
      font-size: 0.9rem;
      color: #ccc;
    }
    .bancos {
      font-size: 0.8rem;
    }
    img {
      width: 100%;
      margin: 0.5rem 0;
    }
    div.button {
      text-align: center;
    }
  }
`;

export const DepositContent = styled(AccordionDetails)`
  background: transparent;
  color: #fff;
  padding: 0 !important;

  > div.pagoEfectivo {
    padding: 1rem 2rem !important;
    h3,
    h4 {
      margin: 0.5rem 0;
    }
    div {
      padding: 0;
      font-size: 0.9rem;
      color: #ccc;
    }
    .bancos {
      font-size: 0.8rem;
    }
    img {
      width: 100%;
      margin: 0.5rem 0;
    }
    div.button {
      text-align: center;
    }
  }
`;

//*** NUEVOS ESTILOS */
export const MenuTop = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const MenuCard = styled.div.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${SECONDARY};
  border: 1px solid ${PRIMARY};
  // margin-right: ${(props) => (props.margin ? 0 : "0.25rem")};
  padding: 0.7rem 0.4rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  > svg {
    width: 32px;
    height: 32px;
    margin-bottom: 5px;
    path {
      transition: all 0.3s ease-in-out;
    }
  }
  > span {
    color: #fff;
    font-size: 1rem;
    font-weight: bold;
  }

  &:hover {
    background-color: ${PRIMARY};
    > svg {
      path {
        fill: ${DARKER};
      }
    }
    > span {
      color: #000;
    }
  }

  &.active {
    background-color: ${PRIMARY}99;
    > svg {
      path {
        fill: ${DARKER};
      }
    }
    > span {
      color: ${DARKER};
    }
  }

  @media screen and (max-width: 2000px) {
    > span {
      font-size: 14px;
    }
    > svg {
      color: ${PRIMARY};
      width: 26px;
      height: 26px;
      margin-bottom: 5px;
    }
  }
  @media screen and (max-width: 1600px) {
    > span {
      font-size: 13px;
    }
    > svg {
      color: ${PRIMARY};
      width: 22px;
      height: 22px;
      margin-bottom: 5px;
    }
  }

  @media screen and (max-width: 768px) {
    > span {
      font-size: 0.8rem;
    }
    > svg {
      width: 25px;
      height: 25px;
    }
    margin-right: 0;
    border-right: ${(props) => (!props.margin ? `1px solid ${DARKER}` : 0)};
  }
  @media screen and (max-width: 480px) {
    > span {
      font-size: 0.7rem;
    }
    > svg {
      width: 22px;
      height: 22px;
    }
    margin-right: 0;
    border-right: ${(props) => (!props.margin ? `1px solid ${DARKER}` : 0)};
  }
`;

export const Content = styled.div`
  position: relative;
  min-height: calc(100%);
  //padding: 0.5rem 10%;
  border-top: 1px solid ${PRIMARY};
  display: flex;
  @media screen and (max-width: 2000px) {
    //padding: 0.5rem 1rem;
  }
  @media screen and (max-width: 1080px) {
    flex-direction: column;
    //padding: 1rem 10%;
  }
  @media screen and (max-width: 768px) {
    //padding: 1rem 5%;
  }
  @media screen and (max-width: 530px) {
    padding: 0;
    //margin-top: 0.5rem;
    margin-bottom: 0;
  }
`;
export const AsideMenu2 = styled.aside.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  flex-direction: column;
  min-height: 400px;

  @media screen and (max-width: 1600px) {
    width: calc(30%);
  }
  @media screen and (max-width: 1080px) {
    width: calc(100%);
    &.hideView {
      display: none;
    }
  }
`;
export const AsideMenu = styled.aside.attrs((props) => ({
  className: props.className,
}))`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  min-height: 400px;
  @media screen and (max-width: 3000px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: calc(100%);
    &.hideView {
      display: none;
    }
  }
  @media screen and (max-width: 1080px) {
    width: calc(100%);
    &.hideView {
      display: none;
    }
  }
  @media screen and (min-width: 840px) and (max-width: 1080px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    &.hideView {
      display: none;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 840px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    &.hideView {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    width: 10%;
    display: block;
    justify-content: column;
    &.hideView {
      display: none;
    }
  }
`;

export const AsideMenuRetiro = styled.aside.attrs((props) => ({
  className: props.className,
}))`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  min-height: 300px;
  margin-bottom: 1rem;
  @media screen and (max-width: 3000px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: calc(100%);
    &.hideView {
      display: none;
    }
  }
  @media screen and (max-width: 1080px) {
    width: calc(100%);
    &.hideView {
      display: none;
    }
  }
  @media screen and (min-width: 840px) and (max-width: 1080px) {
    display: grid;
    min-height: 330px;
    grid-template-columns: repeat(3, 1fr);
    &.hideView {
      display: none;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 840px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    min-height: 330px;
    &.hideView {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    // width: 10%;
    display: block;
    justify-content: column;
    &.hideView {
      display: none;
    }
  }
`;
export const DepositCard = styled.div.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin: 5px;
  margin-top: 20px;
  margin-left: 33px;
  width: 90%;
  height: 130px;
  border: 1px solid ${PRIMARY};
  border-radius: 10px;
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover,
  &.active {
    background-color: #e7e2e2;

    svg {
      color: ${PRIMARY};
    }
  }
  @media screen and (max-width: 3000px) {
    width: 250px;
  }
  @media screen and (min-width: 840px) and (max-width: 1080px) {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (min-width: 600px) and (max-width: 840px) {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (min-width: 580px) and (max-width: 600px) {
    width: 250px;
    align-items: center;
    margin-left: 165px;
  }
  @media screen and (min-width: 560px) and (max-width: 580px) {
    width: 250px;
    align-items: center;
    margin-left: 155px;
  }
  @media screen and (min-width: 540px) and (max-width: 560px) {
    width: 250px;
    align-items: center;
    margin-left: 145px;
  }
  @media screen and (min-width: 520px) and (max-width: 540px) {
    width: 250px;
    align-items: center;
    margin-left: 135px;
  }
  @media screen and (min-width: 500px) and (max-width: 520px) {
    width: 250px;
    align-items: center;
    margin-left: 122px;
  }
  @media screen and (min-width: 480px) and (max-width: 500px) {
    width: 250px;
    align-items: center;
    margin-left: 108px;
  }
  @media screen and (min-width: 460px) and (max-width: 480px) {
    width: 250px;
    align-items: center;
    margin-left: 102px;
  }
  @media screen and (min-width: 430px) and (max-width: 460px) {
    width: 250px;
    align-items: center;
    margin-left: 90px;
  }
  @media screen and (min-width: 400px) and (max-width: 430px) {
    width: 250px;
    align-items: center;
    margin-left: 78px;
  }
  @media screen and (min-width: 380px) and (max-width: 400px) {
    width: 250px;
    align-items: center;
    margin-left: 63px;
  }
  @media screen and (min-width: 350px) and (max-width: 380px) {
    width: 250px;
    align-items: center;
    margin-left: 55px;
  }
  @media screen and (min-width: 320px) and (max-width: 350px) {
    width: 250px;
    align-items: center;
    margin-left: 40px;
  }
  @media screen and (max-width: 320px) {
    width: 250px;
    align-items: center;
    margin-left: 25px;
  }
  @media screen and (min-width: 280px) and (max-width: 320px) {
    width: 250px;
    align-items: center;
    margin-left: 20px;
  }
  @media screen and (max-width: 280px) {
    width: 250px;
    align-items: center;
    margin-left: 5px;
  }
`;
export const DepositCard2 = styled.div.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;

  width: 100%;
  border-bottom: 1px solid ${PRIMARY};
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover,
  &.active {
    background-color: #e7e2e2;

    svg {
      color: ${PRIMARY};
    }
  }
`;

export const WithdrawCard = styled.div.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin: 5px;
  margin-top: 20px;
  margin-left: 33px;
  width: 90%;
  height: 130px;
  border: 1px solid ${PRIMARY};
  border-radius: 10px;
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover,
  &.active {
    background-color: #e7e2e2;

    svg {
      color: ${PRIMARY};
    }
  }
  @media screen and (max-width: 3000px) {
    width: 250px;
  }
  @media screen and (min-width: 840px) and (max-width: 1080px) {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (min-width: 600px) and (max-width: 840px) {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (min-width: 580px) and (max-width: 600px) {
    width: 250px;
    align-items: center;
    margin-left: 165px;
  }
  @media screen and (min-width: 560px) and (max-width: 580px) {
    width: 250px;
    align-items: center;
    margin-left: 155px;
  }
  @media screen and (min-width: 540px) and (max-width: 560px) {
    width: 250px;
    align-items: center;
    margin-left: 145px;
  }
  @media screen and (min-width: 520px) and (max-width: 540px) {
    width: 250px;
    align-items: center;
    margin-left: 135px;
  }
  @media screen and (min-width: 500px) and (max-width: 520px) {
    width: 250px;
    align-items: center;
    margin-left: 122px;
  }
  @media screen and (min-width: 480px) and (max-width: 500px) {
    width: 250px;
    align-items: center;
    margin-left: 108px;
  }
  @media screen and (min-width: 460px) and (max-width: 480px) {
    width: 250px;
    align-items: center;
    margin-left: 102px;
  }
  @media screen and (min-width: 430px) and (max-width: 460px) {
    width: 250px;
    align-items: center;
    margin-left: 90px;
  }
  @media screen and (min-width: 400px) and (max-width: 430px) {
    width: 250px;
    align-items: center;
    margin-left: 78px;
  }
  @media screen and (min-width: 380px) and (max-width: 400px) {
    width: 250px;
    align-items: center;
    margin-left: 63px;
  }
  @media screen and (min-width: 350px) and (max-width: 380px) {
    width: 250px;
    align-items: center;
    margin: 20px auto;
  }
  @media screen and (min-width: 320px) and (max-width: 350px) {
    width: 250px;
    align-items: center;
    margin: 20px auto;
  }
  @media screen and (max-width: 320px) {
    width: 250px;
    align-items: center;
    margin: 20px auto;
  }
  @media screen and (min-width: 280px) and (max-width: 320px) {
    width: 250px;
    align-items: center;
    margin: 20px auto;
  }
  @media screen and (max-width: 280px) {
    width: 250px;
    align-items: center;
    margin-left: 5px;
  }
`;

export const ExpandIcon = styled(ArrowForwardIosIcon)`
  color: ${PRIMARY};
  margin-left: 0.5rem;
`;

export const MainViewContainer = styled.div`
  width: calc(50%);
  margin: 0 auto;
  position: relative;

  @media screen and (max-width: 1080px) {
    width: calc(100%);
    padding-top: 0.5rem;
  }
`;
export const MainViewContainerWithdraw = styled.div`
  width: calc(57%);
  margin: 0 auto;
  position: relative;

  @media screen and (max-width: 1080px) {
    width: calc(100%);
    padding-top: 0.5rem;
  }
  @media screen and (max-width: 768px) {
    padding-top: 1.5rem;
  }
`;

export const ContentSecondary = styled.div`
  position: relative;
  min-height: 400px;
  margin: 0 auto;
  width: 100%;
  //padding: 0.5rem 10%;
  border-top: 1px solid ${PRIMARY};
  padding: 0.5rem 1rem;

  @media screen and (max-width: 1080px) {
    padding: 0;
  }
`;

export const ContentSecondaryBody = styled.div`
  margin: 0 auto;
  width: 70%;
  @media screen and (max-width: 1080px) {
    width: calc(100%);
  }
  //padding: 0.5rem 10%;
`;

export const GoBackButton = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: ${PRIMARY};
  color: ${DARKER};
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    color: ${DARKER};
    font-size: 18px;
    transform: rotate(180deg);
    margin-right: 0.5rem;
  }

  font-weight: bold;
  padding: 0.35rem 0.5rem;
  font-size: 14px;
`;

export const NoMethodSelected = styled.div`
  // color: #00000;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // margin: 3rem auto;
  margin: 0.5rem 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0px;
  bottom: 10px;
  width: 100%;
  p {
    font-weight: bold;
    margin-top: 1rem;
    width: 80%;
    text-align: center;
  }
  svg {
    color: #fff;
    fill: #fff;
  }

  @media screen and (max-width: 1080px) {
    position: relative;
    left: 0;
    bottom: 0;
  }
`;

export const ButtonsContainerTuPay = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AmountButton = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  padding-left: 2%;
  margin-bottom: 15px;
  > Button {
    width: 95% !important;
    font-size: 15px !important;
    border-radius: 10px !important;
    color: #030332 !important;
  }
  Button:hover {
    background-color: ${SECONDARY} !important;
    color: #fff !important;
  }

  @media screen and (min-width: 360px) and (max-width: 429px) {
    > Button {
      width: 95% !important;
      font-size: 12px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 360px) {
    > Button {
      width: 97% !important;
      font-size: 10px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 231px) and (max-width: 320px) {
    > Button {
      width: 95% !important;
      font-size: 10px !important;
      border-radius: 10px !important;
      padding-left: 7%;
    }
  }
  @media screen and (min-width: 200px) and (max-width: 230px) {
    > Button {
      width: 80% !important;
      font-size: 8px !important;
      border-radius: 10px !important;
      padding-left: 8%;
    }
  }
`;

export const AmountButton2 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  padding-left: 2%;
  margin-bottom: 15px;
  > Button {
    width: 95% !important;
    font-size: 13px !important;
    border-radius: 10px !important;
    color: #030332 !important;
  }
  Button:hover {
    background-color: ${SECONDARY} !important;
    color: #fff !important;
  }

  @media screen and (min-width: 360px) and (max-width: 429px) {
    > Button {
      width: 95% !important;
      font-size: 10px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 360px) {
    > Button {
      width: 97% !important;
      font-size: 9px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 231px) and (max-width: 320px) {
    > Button {
      width: 95% !important;
      font-size: 9px !important;
      border-radius: 10px !important;
      padding-left: 7%;
    }
  }
  @media screen and (min-width: 200px) and (max-width: 230px) {
    > Button {
      width: 80% !important;
      font-size: 8px !important;
      border-radius: 10px !important;
      padding-left: 8%;
    }
  }
`;

export const AmountButton3 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  padding-left: 2%;
  margin-bottom: 15px;
  > Button {
    width: 88% !important;
    font-size: 12.5px !important;
    border-radius: 10px !important;
    color: #030332 !important;
  }
  Button:hover {
    background-color: ${SECONDARY} !important;
    color: #fff !important;
  }

  @media screen and (min-width: 429px) and (max-width: 580px) {
    > Button {
      width: 90% !important;
      font-size: 15px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }

  @media screen and (min-width: 360px) and (max-width: 429px) {
    > Button {
      width: 95% !important;
      font-size: 12px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 360px) {
    > Button {
      width: 97% !important;
      font-size: 10px !important;
      border-radius: 10px !important;
      padding-left: -5%;
    }
  }
  @media screen and (min-width: 231px) and (max-width: 320px) {
    > Button {
      width: 95% !important;
      font-size: 10px !important;
      border-radius: 10px !important;
      padding-left: 7%;
    }
  }
  @media screen and (min-width: 200px) and (max-width: 230px) {
    > Button {
      width: 80% !important;
      font-size: 8px !important;
      border-radius: 10px !important;
      padding-left: 8%;
    }
  }
`;
// Definir la animación de parpadeo
const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

// Extender los estilos del label y añadir la animación de parpadeo
export const BlinkingLabel = styled.label`
  color: red !important;
  font-weight: bold;
  font-size: 0.8rem;
  padding: 0.5rem;
  margin-top: 0.5rem;
  animation: ${blink} 1s infinite;
`;

export const DepositTerms = styled.div`
  border: 1px solid ${PRIMARY};
  flex: 1;
  margin: auto;
  margin-left: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-weight: 0.8rem;

  &.retiro {
    margin-bottom: 4.5rem;
    margin-right: 2rem;
  }
  &.hideView {
    display: none;
  }
  @media screen and (max-width: 768px) {
    margin-right: 2rem;
    margin-top: 1rem;

    &.retiro {
      margin-bottom: 1rem;
      margin-top: 0;
    }
  }
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;


export const ButtonFav = styled.button`
  display: flex;
  align-items: center;
  background-color: ${SECONDARY};
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 0;
  font-weight: bold;
  text-transform: uppercase;

  span {
    margin-bottom: 1px;
  }

  &:hover {
    background-color: #d9a017;
  }

  @media screen and (max-width: 768px) {
    padding: 5px;
    font-size: 11px;
    right: 15px;
  }
`;


export const ModalContentFav = styled.div`
  width: 600px;
  min-height: 300px;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 768px) {
    width: 350px;
  }
`;


export const FavoriteItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
  }
`;

export const SelectButton = styled.button`
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 2px;

  &:hover {
    background-color: #45a049;
  }
`;

export const SelectButtons = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 0.5rem;
    flex-direction: row;
    justify-content: space-evenly;
  }

`;

export const DeleteButton = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;


  &:hover {
    background-color: #e53935;
  }
`;